import { NgModule } from '@angular/core';
import { MuiStickyOffsetAnchorDirective } from './mui-sticky-offset-anchor.directive';
import { MuiStickyDirective } from './mui-sticky.directive';


@NgModule({
  declarations: [MuiStickyDirective, MuiStickyOffsetAnchorDirective],
  exports: [MuiStickyDirective, MuiStickyOffsetAnchorDirective]
})
export class MuiStickyModule {}
